import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom'; // ✅ importer BrowserRouter
import ClickSpark from './ClickSpark';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>  {/* ✅ envelopper App avec BrowserRouter */}
      <ClickSpark />
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
